import React, { Component } from 'react';

import {
  ResponseContainer,
  ResponsePlayback,
  ResponsePrivacy,
} from './styledComponents';

class Response extends Component {
  render() {
    const { img, name, playing, status, onClick } = this.props;
    return (
      <ResponseContainer img={img} onClick={() => onClick(name)}>
        <ResponsePlayback img={playing ? 'icons/stop.svg' : 'icons/play.svg'} />
      </ResponseContainer>
    );
  }
}

export default Response;
